<script setup lang="ts">
import { FeatureB2bCreditFormRequest } from '~/components/feature/b2b'
import { ContentBlock } from '~/components/ui/content-block'
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { WidgetReviveAd } from '~/components/widget/revive-ad'
import { WidgetSelectCreditType } from '~/components/widget/select-credit-type'

const { t } = useI18n()

const breadcrumbs = computed(() => [
  { title: t('common.credits'), url: '/credits' },
  { title: t('page.b2b.request.breadcrumb'), url: '/b2b/request' }
])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentLayout>
        <template #right-sidebar>
          <aside>
            <WidgetReviveAd zoneid="27" class="overflow-hidden rounded-lg" />
            <WidgetSelectCreditType
              :query-params="{
                'filter[position]': 'sidebar'
              }"
            />
          </aside>
        </template>
        <div class="space-y-5" role="main">
          <section>
            <ContentBlock
              variant="white"
              :heading-text="t('page.b2b.request.heading')"
              heading-tag="h1"
            >
              <FeatureB2bCreditFormRequest />
            </ContentBlock>
          </section>
        </div>
      </ContentLayout>
    </Container>
  </Main>
</template>
